module.exports = __webpack_public_path__ + "static/media/logawszystkieprostokat.7a9a42bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logawszystkieprostokat.png
// module id = 814
// module chunks = 0